import ScoreIndicator from '@/src/components/score/ScoreIndicator'
import DateIndicator from '@/src/components/score/DateIndicator'
import { FamilyDto } from '@/infra/api/generated/model'
import { t } from 'i18next'
import { getFormattedDateWithYear } from '@/src/utils/dateUtils'

type Props = {
  actionPlanScore: number | null
  family: FamilyDto
  diagnosisDate: string
  diagnosisScore: number
  actionPlanLastUpdatedAt?: string
}

const ActionPlanDiagnosisSummary = ({
  family,
  diagnosisDate,
  actionPlanScore,
  diagnosisScore,
  actionPlanLastUpdatedAt,
}: Props) => {
  const showActionPlanScore = actionPlanScore !== null && actionPlanScore > diagnosisScore

  const formattedDate = getFormattedDateWithYear(new Date(diagnosisDate))

  return (
    <div
      data-testid="action-plan-diagnosis-summary"
      className="w-full flex flex-col gap-4 justify-center items-center"
    >
      <div className="flex flex-col gap-1 items-center text-white">
        <span className="font-semibold text-center text-lg">{`${family.id} - ${family.name}`}</span>

        {!showActionPlanScore && (
          <span className="text-sm font-normal">
            {`${t('components.diagnosis-summary.evaluated-on')} ${formattedDate}`}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-2 justify-center items-center w-full px-8">
        <div
          className={`flex w-full ${showActionPlanScore ? 'justify-between' : 'justify-center'}`}
        >
          <ScoreIndicator
            score={diagnosisScore}
            size="medium"
            direction={showActionPlanScore ? 'vertical' : 'horizontal'}
          />
          {showActionPlanScore && (
            <ScoreIndicator score={actionPlanScore} size="medium" direction="vertical" />
          )}
        </div>
        {showActionPlanScore && (
          <DateIndicator
            diagnosisDate={new Date(diagnosisDate)}
            actionPlanDate={new Date(actionPlanLastUpdatedAt ?? '')}
          />
        )}
      </div>
    </div>
  )
}

export default ActionPlanDiagnosisSummary
